/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Demo_Banner_TextInputs */

const en_ui_demo_banner_text = /** @type {(inputs: Ui_Demo_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're exploring PaceVault with test data`)
};

const de_ui_demo_banner_text = /** @type {(inputs: Ui_Demo_Banner_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du erkundest PaceVault mit Testdaten`)
};

/**
* | output |
* | --- |
* | "You're exploring PaceVault with test data" |
*
* @param {Ui_Demo_Banner_TextInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_demo_banner_text = /** @type {((inputs?: Ui_Demo_Banner_TextInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Demo_Banner_TextInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_demo_banner_text(inputs)
	return de_ui_demo_banner_text(inputs)
});